import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IErrorResponse, IRequestPrevActionBody } from '../types'
import { ModuleID } from '../../types'
import { IAction } from '../../../actions/types'

import { DEBUG_CLIENT } from '../const'
import { getProxyParamsFromUrl, getURLfromAction } from '../lib'

export default async function requestPrevAction(fromAction: IAction) {
  const body: IRequestPrevActionBody = {
    device: ViewportModule.viewport.device,
    mode: fromAction.mode,
    proxy_params: fromAction.action_proxy_params || getProxyParamsFromUrl(fromAction),
    payload: { name: 'back' }
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestPrevAction', body)
  }

  let prevAction = errorAction({ ...fromAction })

  if (fromAction.action_url) {
    try {
      const response = await doPost<IAction | IErrorResponse>(getURLfromAction(fromAction), body).catch(error => {
        DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestPrevAction')
        return errorAction({ ...fromAction })
      })
      prevAction =
        'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction }) : (response as IAction)
      if (!prevAction.mode) {
        prevAction.mode = fromAction.mode
      }
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestPrevAction')
    }
  } else {
    DevLog.error(new Error('no action_url in action'), `SW[${ModuleID.CLIENT}]:`, 'requestPrevAction', fromAction)
  }

  return transferActionProps(fromAction, prevAction)
}
